import { get, post } from '@/util/auth'

import {
  API_PATH_SUB_PC_ADDRESSES,
  API_PATH_SUB_PC_ORDER,
  API_PATH_SUB_PC_PRODUCTS,
} from './apiRoutes'

export const fetchProducts = () => get(API_PATH_SUB_PC_PRODUCTS)

export const fetchAddresses = () => get(API_PATH_SUB_PC_ADDRESSES)

export const postOrder = (order: unknown) => post(API_PATH_SUB_PC_ORDER, order)
